/**
 * Labstep
 *
 * @module components/RichText/Action/Create
 * @desc Action to create comment post
 */

import { FieldType } from 'labstep-web/constants/form';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type { Type } from 'labstep-web/models/rich-text.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import validationRules from 'labstep-web/services/validation/rules';
import type React from 'react';
import type { IRichTextActionCreateProps } from './types';

export const RichTextActionCreate: React.FC<
  IRichTextActionCreateProps
> = ({ create, status }) => (
  <Modal
    size="fullscreen"
    header={`Create ${getHumanReadableEntityName('rich_text')}`}
    content={({ toggleModal }) => (
      <FormReusable
        status={status}
        fields={[
          {
            name: 'description',
            fieldType: FieldType.ProseMirrorHtml,
            validation: validationRules.rich_text.description,
          },
        ]}
        onSubmit={({ description }) => {
          create(
            {
              rich_text: {
                type: 'html' as Type,
                description: description as string,
              },
            } as any,
            { onSuccess: toggleModal },
          );
        }}
      />
    )}
    viewComponent={({ toggleModal }) => (
      <ActionComponent
        type="option"
        onClick={toggleModal}
        text="Long text"
        icon="file text"
      />
    )}
  />
);
